import React from 'react';
import { styled } from 'linaria/react';
import { breakpoints } from '../../../../../media';

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: calc(100% + 32px);
	height: 100%;
	max-height: 165px;
	margin-top: -16px;
	margin-bottom: 8px;
	background-color: var(--background-secondary);
	border-radius: 8px 8px 0 0;
	margin-inline: -16px;

	& svg {
		width: 65%;
		height: 65%;
	}

	${breakpoints.only.mobile} {
		max-width: 140px;
		margin-right: 4px;
		margin-left: 0;
		border-radius: 8px;
		margin-block: 0;
	}
`;

export const NoPhoto = () => (
	<Wrapper data-qa="card-no-photo" data-analyticsName="productPhotoLink">
		<svg viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g fill="#cdd0d5" fillRule="nonzero">
					<path d="M16.9510797,2.50304787 C17.7274884,2.50304787 18.4490393,2.9033378 18.8600157,3.56205529 L20.3810589,6 L22.75,6 C24.5449254,6 26,7.45507456 26,9.25 L26,21.75 C26,23.5449254 24.5449254,25 22.75,25 L5.25,25 C3.45507456,25 2,23.5449254 2,21.75 L2,9.25 C2,7.45507456 3.45507456,6 5.25,6 L7.81851226,6 L9.2010861,3.62210494 C9.60389995,2.92930357 10.3448058,2.50304787 11.1462,2.50304787 L16.9510797,2.50304787 Z M16.9510797,4.00304787 L11.1462,4.00304787 C10.9172302,4.00304787 10.7030739,4.10743702 10.5620036,4.28269019 L10.4978287,4.3760669 L8.8983713,7.12698098 C8.76410002,7.35791477 8.51713142,7.5 8.25,7.5 L5.25,7.5 C4.28350169,7.5 3.5,8.28350169 3.5,9.25 L3.5,21.75 C3.5,22.7164983 4.28350169,23.5 5.25,23.5 L22.75,23.5 C23.7164983,23.5 24.5,22.7164983 24.5,21.75 L24.5,9.25 C24.5,8.28350169 23.7164983,7.5 22.75,7.5 L19.9649865,7.5 C19.7061837,7.5 19.4656667,7.36657003 19.3286745,7.14699753 L17.5873917,4.35605034 C17.4503996,4.13647785 17.2098826,4.00304787 16.9510797,4.00304787 Z M14,9.5009905 C17.0375661,9.5009905 19.5,11.9634244 19.5,15.0009905 C19.5,18.0385566 17.0375661,20.5009905 14,20.5009905 C10.9624339,20.5009905 8.5,18.0385566 8.5,15.0009905 C8.5,11.9634244 10.9624339,9.5009905 14,9.5009905 Z M14,11.0009905 C11.790861,11.0009905 10,12.7918515 10,15.0009905 C10,17.2101295 11.790861,19.0009905 14,19.0009905 C16.209139,19.0009905 18,17.2101295 18,15.0009905 C18,12.7918515 16.209139,11.0009905 14,11.0009905 Z" />
				</g>
			</g>
		</svg>
	</Wrapper>
);
